import axios from 'axios';
import { Loading, Message } from 'element-ui';
import { baseURL } from './url';
import router from '@/router';

class Axios {
  constructor() {
    this.axiosInstance = null;
    this.loadingInstance = null; // 用来管理loading状态
    this.init();
  }

  init() {
    const config = {
      baseURL,
      timeout: 30000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    // 创建axios实例
    this.axiosInstance = axios.create(config);

    // 请求拦截器
    this.axiosInstance.interceptors.request.use(
      (config) => {
        // 在请求前启动loading
        // if (!this.loadingInstance && config.url !== 'http://www.schtyg.cn:3930/admin/order/is_or') {
        //   this.loadingInstance = Loading.service({
        //     lock: true,
        //     text: 'Loading...',
        //     spinner: 'el-icon-loading',
        //     background: 'rgba(0, 0, 0, 0.7)',
        //   });
        // }
        let token = sessionStorage.getItem('access_token')
        if (token) {
          config.headers['access_token'] = token// token
        }
        return config;
      },
      (error) => {
        // 关闭loading并处理请求错误
        this.closeLoading();
        Message.error('请求错误');
        return Promise.reject(error);
      }
    );

    // 响应拦截器
    this.axiosInstance.interceptors.response.use(
      (response) => {
        // 响应成功后关闭loading
        this.closeLoading();
        // if (response.data.code === 213 || response.data.code === 400) {
        if (response.data.errCode === 60001 || response.data.errCode === 60002 || response.data.errCode === 60003) {
          Cookie.set('id', '')
          Cookie.set('name', '')
          sessionStorage.removeItem('access_token')
          Message.warning(response.data.msg);
          router.push('/login');
        }
        return response;
      },
      (error) => {
        // 处理响应错误并关闭loading
        this.closeLoading();
        const status = error.response ? error.response.status : '网络错误';
        const errorMessage = error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].message
          : '请求失败';

        Message.error({
          title: `错误 ${status}`,
          message: errorMessage,
        });

        if (status === 401) {
          // 未授权，跳转到登录页面
          router.push('/login');
        }

        return Promise.reject(error);
      }
    );
  }

  // 关闭loading的函数
  closeLoading() {
    if (this.loadingInstance) {
      this.loadingInstance.close();
      this.loadingInstance = null;
    }
  }

  // GET请求
  get(url, config) {
    return this.axiosInstance.get(url, config);
  }

  // POST请求
  post(url, data, config) {
    return this.axiosInstance.post(url, data, config);
  }

  // 同时发送多个请求
  async all(requests) {
    return await axios.all(requests);
  }
}

export default new Axios();



// WEBPACK FOOTER //
// ./src/utils/axios.js